"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetSaver = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _AssetUtils = require("../Utility/AssetUtils");

var _Config = require("../Utility/Config");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AssetSaver = /*#__PURE__*/function () {
  function AssetSaver(config, asset, file) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, AssetSaver);
    (0, _defineProperty2["default"])(this, "api", void 0);
    (0, _defineProperty2["default"])(this, "replaceAsset", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(file, asset, config) {
        var formData, renamed, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formData = new FormData();
                renamed = new File([file], _this.getFileName(asset), {
                  type: file.type
                });
                formData.append("file", renamed);
                _context.next = 5;
                return _this.makeMultipartRequest(formData, config, "/".concat(asset.id, "/content"), "PUT");

              case 5:
                response = _context.sent;
                _context.next = 8;
                return response.json();

              case 8:
                return _context.abrupt("return", _context.sent);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "uploadImage", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(asset, file, config) {
        var formData, renamed, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = new FormData();
                renamed = new File([file], _this.getFileName(asset), {
                  type: file.type
                });
                formData.append("file", renamed);
                formData.set("fileName", asset.fileName);

                if (asset.permissionSet) {
                  _context2.next = 6;
                  break;
                }

                throw new Error("Asset is missing permission set.");

              case 6:
                formData.append("permissionSet", asset.permissionSet.id);

                if (asset.categories) {
                  asset.categories.forEach(function (a) {
                    if (a.id) formData.append("categories", a.id);
                  });
                }

                if (asset.metadata) {
                  Object.keys(asset.metadata).forEach(function (propName) {
                    return formData.append("metadata[".concat(propName, "]"), asset.metadata[propName]);
                  });
                }

                if (asset.tags) {
                  asset.tags.forEach(function (a) {
                    return formData.append("tags", a);
                  });
                }

                _context2.next = 12;
                return _this.makeMultipartRequest(formData, config);

              case 12:
                response = _context2.sent;
                _context2.next = 15;
                return response.json();

              case 15:
                return _context2.abrupt("return", _context2.sent);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "getFileName", function (asset) {
      return (0, _AssetUtils.getFileExtension)(asset.fileName) === asset.fileExtension ? asset.fileName : "".concat(asset.fileName, ".").concat(asset.fileExtension);
    });
    (0, _defineProperty2["default"])(this, "makeMultipartRequest", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(formData, config) {
        var _config$accessToken;

        var url,
            method,
            token,
            response,
            error,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : "";
                method = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : "POST";

                if (!((_config$accessToken = config.accessToken) !== null && _config$accessToken !== void 0)) {
                  _context3.next = 6;
                  break;
                }

                _context3.t0 = _config$accessToken;
                _context3.next = 9;
                break;

              case 6:
                _context3.next = 8;
                return new _sdk.AssetsApi(config).generateToken();

              case 8:
                _context3.t0 = _context3.sent;

              case 9:
                token = _context3.t0;
                _context3.next = 12;
                return fetch("".concat(config.baseUrl, "/api/apps/").concat(config.appName, "/assets").concat(url), {
                  method: method,
                  body: formData,
                  headers: {
                    Authorization: "Bearer " + token
                  }
                });

              case 12:
                response = _context3.sent;

                if (!(response.status !== 201 && response.status !== 200)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 16;
                return response.json();

              case 16:
                error = _context3.sent;
                throw new Error(error.message);

              case 18:
                return _context3.abrupt("return", response);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x7, _x8) {
        return _ref3.apply(this, arguments);
      };
    }());
    this.api = new _sdk.AssetsApi((0, _Config.includeFlow)(config));
    this.asset = asset;
    this.file = file;
    this.config = config;
  }

  (0, _createClass2["default"])(AssetSaver, [{
    key: "save",
    value: function () {
      var _save = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(status) {
        var result, replaceAssetResult, metadata, _metadata, pixelHeight, pixelWidth, existingMetadata, _result$_meta, _this$asset$scheduleJ;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.asset.id) {
                  _context4.next = 16;
                  break;
                }

                if (!(this.file && this.file instanceof File)) {
                  _context4.next = 9;
                  break;
                }

                if ((0, _AssetUtils.getFileExtension)(this.file.name) !== this.asset.fileExtension) {
                  //set the new extension in case the file was replaced
                  this.asset.fileExtension = (0, _AssetUtils.getFileExtension)(this.file.name);
                }

                _context4.next = 5;
                return this.replaceAsset(this.file, this.asset, this.config);

              case 5:
                replaceAssetResult = _context4.sent;

                if (!(!status && this.asset.status === "Published" && !this.asset.newStatus)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 9;
                return this.api.putAssetStatus(this.config.appName, this.asset.id, {
                  status: "Published",
                  notificationDetails: this.asset.notificationDetails
                });

              case 9:
                metadata = this.asset.metadata;

                if (replaceAssetResult) {
                  //dont replace pixelWidth and pixelHeight
                  _metadata = metadata, pixelHeight = _metadata.pixelHeight, pixelWidth = _metadata.pixelWidth, existingMetadata = (0, _objectWithoutProperties2["default"])(_metadata, ["pixelHeight", "pixelWidth"]);
                  metadata = _objectSpread(_objectSpread({}, replaceAssetResult.metadata), existingMetadata);
                }

                _context4.next = 13;
                return this.api.putAsset(this.config.appName, this.asset.id, new _sdk.AnnotateAssetDto({
                  fileName: this.asset.fileName,
                  slug: this.asset.slug,
                  isProtected: this.asset.isProtected,
                  tags: this.asset.tags,
                  categories: this.asset.categories,
                  metadata: metadata,
                  emailAddresses: this.asset.emailAddresses,
                  permissionSet: this.asset.permissionSet
                }));

              case 13:
                result = _context4.sent;
                _context4.next = 21;
                break;

              case 16:
                _context4.next = 18;
                return this.uploadImage(this.asset, this.file, this.config);

              case 18:
                result = _context4.sent;

                if (!((_result$_meta = result._meta) !== null && _result$_meta !== void 0 && _result$_meta.isDuplicate)) {
                  _context4.next = 21;
                  break;
                }

                throw new Error("Asset has already been uploaded.");

              case 21:
                if (!(status && result.id)) {
                  _context4.next = 25;
                  break;
                }

                _context4.next = 24;
                return this.api.putAssetStatus(this.config.appName, result.id, {
                  status: status,
                  dueTime: (_this$asset$scheduleJ = this.asset.scheduleJob) === null || _this$asset$scheduleJ === void 0 ? void 0 : _this$asset$scheduleJ.dueTime,
                  notificationDetails: this.asset.notificationDetails
                });

              case 24:
                result = _context4.sent;

              case 25:
                return _context4.abrupt("return", result);

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function save(_x9) {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }]);
  return AssetSaver;
}();

exports.AssetSaver = AssetSaver;